var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"fs-20",class:_vm.dynamicClasses(_vm.wrapContent)},[_vm._v(" "+_vm._s(_vm.primary)+" ")]),_c('div',{staticClass:"fs-16",class:_vm.dynamicClasses(_vm.wrapContent)},[_vm._v(" "+_vm._s(_vm.secondary)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }